import React from 'react'
import Header from '../../Components/Header/header';
import Banner from '../../Components/Banner/banner';
import Special from '../../Components/Special/special';
import Card from '../../Components/Card/card';
import Data from '../../Components/App/Data';
import ImageSlider from '../../Components/ImageSlider/imageSlider';
import ChefImage from '../../Components/ChefImage/chefImage';
import ContactField from '../../Components/ContactField/contactField';
import Reach from '../../Components/Reach/reach';
import FootPage from '../../Components/FooterPage/footPage';
import './Home.css';

export default function Home() {

    const cards = Data.map(item => {
        return (
          <Card 
          key={item.id}
          {...item}
          />
        )
      })


  return (
    <div className='Home'>
        <Header />
      <div className="banner-container">
      <Banner />
      </div>
      <div className="theSpecial">
        <Special />
        <div className="cards">
          {cards}
        </div>
      </div>
      <div className="slider-images">
        <ImageSlider />
        </div>
        <ChefImage />
        <div className="fieldInput">
        <ContactField />
        </div>
        <Reach />
        <div className="footPage">
          <FootPage />
        </div>
    </div>
  )
}
